import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
} from '@mui/icons-material';

function About() {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pt: 12, pb: 4 }}>
      <Container maxWidth="lg">
        {/* About Section */}
        <Box sx={{ mb: 6 }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: 'primary.main',
            }}
          >
            About Us
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            Welcome to the Merrimack Valley Youth Program (MVYP), a registered 501(c)(3) nonprofit organization dedicated to empowering young Muslims in our community. Since receiving our nonprofit status in May 2025, we have been committed to creating a supportive and engaging environment where middle and high school students can grow in their faith, build meaningful connections, and develop into confident leaders.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            Our mission is clear: to empower young Muslims in the Merrimack Valley through faith-based education, community engagement, and leadership development, nurturing a confident generation grounded in Islamic values and committed to serving society. We achieve this through our weekly youth program that runs for two-thirds of the year, bringing together students for sessions filled with games, life lessons, Islamic education, and opportunities for self-expression in a safe and welcoming space.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            What makes MVYP special is our mentor-mentee model. College students and young professionals volunteer their time to mentor our middle and high school participants, providing positive role models and personalized guidance. Our curriculum focuses on Islamic figures and history, helping students build a strong foundation in their faith while developing character and life skills. We complement our weekly sessions with exciting outings and retreats—from bowling and laser tag to our recent ski retreat—creating memorable experiences that strengthen bonds within our community.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            Currently serving 40-50 students per semester, we are actively growing to reach more youth in the Merrimack Valley. Every session is designed to be more than just an activity—it's an opportunity for students to connect with their peers, learn from mentors, explore their Islamic identity, and develop the confidence and values they need to thrive in today's world. Join us in building a stronger, more connected Muslim community, one young person at a time.
          </Typography>
        </Box>

        {/* Contact Information Section */}
        <Box>
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 700,
              mb: 3,
              color: 'primary.main',
            }}
          >
            Contact Us
          </Typography>
          <Paper
            elevation={2}
            sx={{
              p: 4,
              bgcolor: 'background.paper',
              borderRadius: 2,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
              {/* Email */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <EmailIcon sx={{ fontSize: 30, color: 'primary.main' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Email
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    contact@mvyp.org
                  </Typography>
                </Box>
              </Box>

              {/* Phone */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <PhoneIcon sx={{ fontSize: 30, color: 'primary.main' }} />
                <Box>
                  <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                    Phone
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    978-394-6290
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default About;
